import { BoxBase, ButtonBase, DialogBase, TypographyBase } from '@fmc-digital/ui';
import React from 'react';
import { UIConstants } from '@constants';
import i18next from 'i18next';

export const PaperlessModal = ({ onEnroll, title, open }: any) => {
    const modalTextLines = i18next.t('paperlessTerms', {
        returnObjects: true,
        ns: 'translation'
    }) as string[];
    const [first, second, third, fourth, fifth, sixth, seventh, eight, nine, ten, eleven, ...rest] = modalTextLines;
    const { enrollNow } = UIConstants;
    const renderDialogContent = () => {
        return (
            <TypographyBase>
                <TypographyBase variant="caption-bold">{first}</TypographyBase>
                <ol>
                    {[second, third].map((text, index) => (
                        <li key={`ol-li-${index}`}>
                            <TypographyBase variant="caption-bold" key={`line-${index}`}>
                                {text}
                            </TypographyBase>
                        </li>
                    ))}
                    <TypographyBase
                        variant="caption"
                        sx={{
                            whiteSpace: 'pre-wrap',
                            marginTop: 2,
                            display: 'flex'
                        }}
                    >
                        {fourth}
                    </TypographyBase>
                    <TypographyBase variant="caption" sx={{ whiteSpace: 'pre-wrap', margin: `4px 0`, display: 'flex' }}>
                        {fifth}
                    </TypographyBase>
                    <ul>
                        {[sixth, seventh].map((text, idx) => (
                            <li key={`line-${idx}-li`}>
                                <TypographyBase variant="caption" key={`line-${idx}`}>
                                    {text}
                                </TypographyBase>
                            </li>
                        ))}
                    </ul>
                    <TypographyBase variant="caption" sx={{ whiteSpace: 'pre-wrap', margin: `4px 0`, display: 'flex' }}>
                        {eight}
                    </TypographyBase>
                    <ul>
                        {[nine, ten, eleven].map((text, idx) => (
                            <li key={`paperless-${idx}`}>
                                <TypographyBase variant="caption" key={`paperless-${idx}`}>
                                    {text}
                                </TypographyBase>
                            </li>
                        ))}
                    </ul>
                </ol>
                <TypographyBase variant="caption">{rest}</TypographyBase>
            </TypographyBase>
        );
    };
    const renderDialogActions = () => {
        return (
            <BoxBase sx={{ display: 'flex', justifyContent: 'flex-end', alignSelf: 'flex-end' }}>
                <ButtonBase variant="contained" onClick={() => onEnroll(enrollNow)}>
                    Enroll Now
                </ButtonBase>
            </BoxBase>
        );
    };
    return (
        <DialogBase
            handleClose={() => onEnroll('close_modal')}
            open={open}
            renderDialogContent={renderDialogContent}
            title={title}
            renderDialogActions={renderDialogActions}
        />
    );
};
